import React, { FC, ReactNode, HTMLAttributes } from "react";

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  cardTitle: string;
  children: ReactNode;
  cardHeaderRightContent?: ReactNode;
}

export const Card: FC<CardProps> = ({
  cardTitle,
  children,
  cardHeaderRightContent,
  className = "",
  style,
  ...rest
}) => (
  <div className={`card ${className}`} style={style} {...rest}>
    <div className="card-header contactListHeader d-flex justify-content-between align-items-center overview-product">
      <div className="cardTitle">{cardTitle}</div>
      <div className="cardHeaderRightContent">{cardHeaderRightContent}</div>
    </div>
    <div className="card-body h350">{children}</div>
  </div>
);
